export const WHATSAPP_REPLY_BUTTON_TITLE_LIMIT = 20;
export const WHATSAPP_INTERACTIVE_BODY_LIMIT = 1024;
export const WHATSAPP_LIST_ROW_TITLE_LIMIT = 24;
export const WHATSAPP_LIST_ROW_DESCRIPTION_LIMIT = 72;
export const WHATSAPP_REPLY_BUTTON_ID_LIMIT = 256;
export const WHATSAPP_LIST_ROW_ID_LIMIT = 200;
export const WHATSAPP_INTERACTIVE_OPTION_MAX = 10;

export const normalizeChoiceTerms = rawTerms => {
  if (Array.isArray(rawTerms)) {
    return Array.from(
      new Set(
        rawTerms
          .map(term => String(term ?? "").trim())
          .filter(Boolean)
      )
    );
  }

  if (typeof rawTerms === "string") {
    return Array.from(
      new Set(
        rawTerms
          .split(",")
          .map(term => term.trim())
          .filter(Boolean)
      )
    );
  }

  return [];
};

export const getChoiceInteractiveMode = optionCount =>
  optionCount > 3 ? "list" : "buttons";

export const getChoiceTitleLimit = optionCount =>
  getChoiceInteractiveMode(optionCount) === "list"
    ? WHATSAPP_LIST_ROW_TITLE_LIMIT
    : WHATSAPP_REPLY_BUTTON_TITLE_LIMIT;

export const getChoiceValueLimit = optionCount =>
  getChoiceInteractiveMode(optionCount) === "list"
    ? WHATSAPP_LIST_ROW_ID_LIMIT
    : WHATSAPP_REPLY_BUTTON_ID_LIMIT;

export const validateChoiceConfig = config => {
  const promptText = String(config?.promptText || config?.message || "").trim();
  const options = Array.isArray(config?.options) ? config.options : [];
  const optionCount = options.length;
  const mode = getChoiceInteractiveMode(optionCount);
  const titleLimit = getChoiceTitleLimit(optionCount);
  const valueLimit = getChoiceValueLimit(optionCount);
  const globalErrors = [];
  const optionErrors = options.map(() => ({}));
  let promptError = "";

  if (!promptText) {
    promptError = "Prompt text is required.";
  } else if (promptText.length > WHATSAPP_INTERACTIVE_BODY_LIMIT) {
    promptError = `Prompt text must be ${WHATSAPP_INTERACTIVE_BODY_LIMIT} characters or fewer.`;
  }

  if (promptError) {
    globalErrors.push(promptError);
  }

  if (optionCount < 1) {
    globalErrors.push("Add at least 1 option.");
  }

  if (optionCount > WHATSAPP_INTERACTIVE_OPTION_MAX) {
    globalErrors.push(
      `WhatsApp interactive choices support up to ${WHATSAPP_INTERACTIVE_OPTION_MAX} options per message.`
    );
  }

  options.forEach((option, index) => {
    const label = String(option?.label || "").trim();
    const value = String(option?.value || "").trim();
    const description = String(option?.description || "").trim();

    if (!label) {
      optionErrors[index].label = "Label is required.";
    } else if (label.length > titleLimit) {
      optionErrors[index].label =
        mode === "list"
          ? `List title must be ${WHATSAPP_LIST_ROW_TITLE_LIMIT} characters or fewer.`
          : `Button title must be ${WHATSAPP_REPLY_BUTTON_TITLE_LIMIT} characters or fewer.`;
    }

    if (!value) {
      optionErrors[index].value = "Value is required.";
    } else if (value.length > valueLimit) {
      optionErrors[index].value = `Value must be ${valueLimit} characters or fewer.`;
    }

    if (mode === "list" && description.length > WHATSAPP_LIST_ROW_DESCRIPTION_LIMIT) {
      optionErrors[index].description = `List description must be ${WHATSAPP_LIST_ROW_DESCRIPTION_LIMIT} characters or fewer.`;
    }
  });

  return {
    isValid:
      globalErrors.length === 0 &&
      optionErrors.every(
        entry => !entry.label && !entry.value && !entry.description
      ),
    mode,
    optionCount,
    titleLimit,
    valueLimit,
    promptLimit: WHATSAPP_INTERACTIVE_BODY_LIMIT,
    promptError,
    globalErrors,
    optionErrors,
  };
};
